import template from "./read-only-text.html";
import "./read-only-text.less";

export class Controller {
	selection = {};

	constructor($sce) {
		this.$sce = $sce;
	}

	$onInit() {
		this._unregister = this.reportFormCtrl.registerFieldController(this);
	}

	getCurrentValue() {
		return [];
	}
}

export default angular
	.module("vesl.components.report-form.read-only-text", [])
	.component("readOnlyText", {
		template,
		controller: Controller,
		bindings: {
			field: "<",
			values: "<",
			setFieldDirty: "="
		},
		require: {
			reportFormCtrl: "^reportForm"
		}
	}).name;
